// Lógica pura de la sincronización de presets del video wall con apiv2.
// Diseño: docs/superpowers/specs/2026-09-29-tray-presets-db-design.md

// Solo lo que persiste el backend; el id viaja en la URL (PUT) o en el item
// (import).
export function toPresetPayload(preset) {
  const out = {
    name: preset.name || 'Preset',
    createdAt: preset.createdAt,
    tiles: preset.tiles || [],
  }
  if (preset.cols != null) out.cols = preset.cols
  return out
}

// Sincroniza los presets de un usuario en ESTE origen.
//   api: { importMany(presets), list() }
//   localPresets: lo que hay en localStorage (legado o caché)
//   migrated: flag trayPresetsMigrated:<uid> de este origen
// → { ok, presets, migrated, error? } — con ok=false el caller conserva su
// lista local.
// El flag significa "el LS de este origen ya deriva del server": se marca en
// el primer sync exitoso aunque no hubiera nada que importar, para que la
// caché nunca se re-importe (resucitaría presets borrados en otro origen).
export async function syncPresets({ api, localPresets, migrated }) {
  const local = Array.isArray(localPresets) ? localPresets : []
  let isMigrated = !!migrated
  if (!isMigrated && local.length) {
    try {
      await api.importMany(local)
      isMigrated = true
    } catch (error) {
      // Sin GET: pisaría la caché y los presets aún no migrados se perderían
      // antes del reintento.
      return {
        ok: false, presets: local, migrated: false, error,
      }
    }
  }
  try {
    const presets = await api.list()
    return { ok: true, presets: Array.isArray(presets) ? presets : [], migrated: true }
  } catch (error) {
    return {
      ok: false, presets: local, migrated: isMigrated, error,
    }
  }
}

// Operaciones locales hechas MIENTRAS el sync estaba en vuelo: el GET pudo
// resolverse antes de que llegaran al server, así que se re-aplican sobre la
// lista recibida. ops: [{ type: 'upsert', preset } | { type: 'delete', id }]
export function applyPendingOps(list, ops) {
  let out = list.slice()
  ops.forEach((op) => {
    if (op.type === 'delete') {
      out = out.filter(p => p.id !== op.id)
      return
    }
    const idx = out.findIndex(p => p.id === op.preset.id)
    if (idx >= 0) out[idx] = op.preset
    else out.push(op.preset)
  })
  return out
}
